import { get, writable } from 'svelte/store';
import { RecipeService } from '../../services/recipe.service';
export const filterRecipeId = writable(0);
export const loading = writable(false);
export const editing = writable(false);
export const records = writable([]);
export const record = writable(null);
export async function initList(recipeId) {
    record.set(null);
    filterRecipeId.set(recipeId);
    await load();
    initDetail();
}
export async function initDetail() {
    editing.set(false);
    record.set({
        oid: 0,
        recipeId: get(filterRecipeId),
        clfIngredientTypeId: 0,
        quantity: 0,
    });
}
export async function load() {
    loading.set(true);
    editing.set(false);
    try {
        let _recipeId = get(filterRecipeId);
        let _resp = await RecipeService.getRecipeIngredients(_recipeId);
        records.set(_resp.payload);
    }
    finally {
        loading.set(false);
    }
}
export function onEdit(item) {
    record.set(item.recipeIngredient);
    editing.set(true);
}
export async function save() {
    let _record = get(record);
    editing.set(false);
    return await RecipeService.saveRecipeIngredient(_record);
}
export async function onDelete(item) {
    await RecipeService.deleteRecipeIngredient(item.oid);
    await load();
}
